export const app = {
    title: 'Form Generateur IT'
}
